import { BarChart3, Target, CircleDot, Shirt } from "lucide-react";

function PlayerFeaturedStats({ gamesPlayed, getTotalStatValue }) {
 const featuredStatConfig = [
  {
   key: "ppg",
   label: "PPG",
   stat: "PTS",
   type: "average",
   subtitle: "Points Per Game",
   icon: BarChart3,
  },
  {
   key: "ftPercentage",
   label: "FT%",
   made: "FTM",
   attempted: "FTA",
   type: "percentage",
   subtitle: "Free Throw %",
   icon: Target,
  },
  {
   key: "threePerGame",
   label: "3PG",
   stat: "3PM",
   type: "average",
   subtitle: "3-Pointers Per Game",
   icon: CircleDot,
  },
  {
   key: "gamesPlayed",
   label: "GAMES PLAYED",
   type: "gamesPlayed",
   subtitle: "Games Played",
   icon: Shirt,
  },
 ];

 const getFeaturedStatValue = (item) => {
  if (item.type === "gamesPlayed") {
   return gamesPlayed;
  }

  if (item.type === "total") {
   return getTotalStatValue(item.stat);
  }

  if (item.type === "average") {
   const total = getTotalStatValue(item.stat);
   return gamesPlayed ? (total / gamesPlayed).toFixed(1) : "0.0";
  }

  if (item.type === "percentage") {
   const made = getTotalStatValue(item.made);
   const attempted = getTotalStatValue(item.attempted);

   return attempted ? `${((made / attempted) * 100).toFixed(1)}%` : "0.0%";
  }

  return "—";
 };

 return (
  <div className="hero-stat-strip">
   {featuredStatConfig.map((item) => {
    const Icon = item.icon;

    return (
     <div className="hero-stat" key={item.key}>
      {/* <Icon size={29} /> */}

      <div className="inner-hero-stat">
       <p>{item.label}</p>
       <h3>{getFeaturedStatValue(item)}</h3>
       <span>{item.subtitle}</span>
      </div>
     </div>
    );
   })}
  </div>
 );
}

export default PlayerFeaturedStats;